var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Manage redirection")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm.hostingDomain
              ? [
                  _vm.withAlert
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "py-2 px-2",
                          attrs: {
                            type: "info",
                            outlined: ""
                          }
                        },
                        [
                          _c("strong", [_vm._v("Note")]),
                          _vm._v(
                            ": To redirect to a file, end the URL with a trailing slash (for example: “mydomain1.com” → “example.com/index.html/”). "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.editMode
                    ? [
                        _c("p", [
                          _vm._v("Domain "),
                          _c("b", [_vm._v(_vm._s(_vm.hostingDomain.domain))]),
                          _vm._v(" redirects to:")
                        ]),
                        _c("gg-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "url:require_protocol",
                              expression: "'url:require_protocol'"
                            }
                          ],
                          staticClass: "gg-input",
                          attrs: {
                            label: "Redirection",
                            name: "Redirection",
                            "error-messages": _vm.errors.collect("Redirection")
                          },
                          model: {
                            value: _vm.redirection,
                            callback: function callback($$v) {
                              _vm.redirection = $$v
                            },
                            expression: "redirection"
                          }
                        })
                      ]
                    : [
                        _c("p", [
                          _vm._v(" Domain "),
                          _c("b", [_vm._v(_vm._s(_vm.hostingDomain.domain))]),
                          _vm._v(" does not have redirection enabled. "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "#"
                              },
                              on: {
                                click: function click($event) {
                                  $event.preventDefault()
                                  _vm.editMode = true
                                }
                              }
                            },
                            [_vm._v("Enable redirection.")]
                          )
                        ])
                      ]
                ]
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  disabled: !_vm.actionsAvailable,
                  loading: _vm.isWaitingForApplyResponse
                },
                on: {
                  click: _vm.changeRedirection
                }
              },
              [_vm._v("Apply")]
            ),
            _vm.hasRedirection
              ? _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      disabled: !_vm.actionsAvailable,
                      loading: _vm.isWaitingForDisableResponse
                    },
                    on: {
                      click: _vm.disableRedirection
                    }
                  },
                  [_vm._v("Disable Redirection")]
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }